import { type Environment } from './environment.type'

export const environment: Environment = {
  production: false,

  // Auth0 (CARTO3)
  API_BASE_URL: 'https://gcp-europe-west1.api.carto.com',
  AUTH_ENABLED: true,
  AUTH_CLIENT_ID: 'gKFhU9X0EzkdXprJ7aFb4NQ4eFnxZ3xk',
  AUTH_DOMAIN: 'auth.carto.com',
  CARTO_CONNECTION: 'app_dev',
  CARTO_SOURCE_PREFIX: 'dev',
  // OOH_API_BASE_URL: 'https://gooh-politis-api-dev.carto.solutions',
  OOH_API_BASE_URL: 'https://api-cloud-run-y76ca6lxza-ew.a.run.app',

  // Map
  legendMaxValue: -1,

  // UI
  availableLangs: ['en', 'es', 'el'],
  frontConfig: {
    showVodafoneTitle: false,
  },
  vodafoneGroup: true,
  politis: true,
  i18Template: 'politis',
}
